// import loadMapsAPI from 'lib/loadMapsAPI';

const extractLatLon = results => {
  const firstResult = results[0] || false;
  if (!firstResult || !firstResult.geometry || !firstResult.geometry.location)
    return null;

  const latitude = firstResult.geometry.location.lat();
  const longitude = firstResult.geometry.location.lng();

  return { latitude, longitude };
};

const retrieveLatLong = async city => {
  let geocoder;

  if (city) {
    // eslint-disable-next-line no-undef
    const { Geocoder } = google.maps;
    geocoder = new Geocoder();
  }

  return new Promise((resolve, reject) => {
    if (!city) {
      reject(Error('No city value provided'));
    } else {
      geocoder.geocode(
        {
          address: `${city} Nederland`,
        },
        (results, status) => {
          if (status === 'OK') {
            const { latitude, longitude } = extractLatLon(results);
            resolve([latitude, longitude]);
          } else {
            reject(Error('LatLong could not be retrieved'));
          }
        }
      );
    }
  });
};

export default retrieveLatLong;
